export enum TimeSelectorTitles {
  TODAY = 'AUCTION--TIME-SELECTOR:title-today',
  YESTERDAY = 'AUCTION--TIME-SELECTOR:title-yesterday',
  TOMORROW = 'AUCTION--TIME-SELECTOR:title-tomorrow'
}